import React, {forwardRef} from "react";
import classNames from "classnames";

import {InputField} from "@pg-design/inputs-module";

import {inputHolder, rangeHolder, separator} from "./RangeInput.module.css";

export interface IRange<T> {
    lower: T;
    upper: T;
    bounds?: string;
}

type RangeLimitValue = string | number;

export interface IRangeProps {
    className?: string;
    name: string;
    value: IRange<RangeLimitValue>;
    error?: string | string[];
    onChange: (name: string, value: IRange<RangeLimitValue>) => void;
    rightElement?: React.JSX.Element | string;
    dataTestIdLower?: string;
    dataTestIdUpper?: string;
}

export const RangeInput = forwardRef<HTMLDivElement, IRangeProps>((props, inputForwardedRef) => {
    const {name, value, className, onChange, dataTestIdLower, dataTestIdUpper} = props;

    const handlers = {
        onChange: (inputName: string, fieldValue: string) => {
            if (inputName === `${name}__lower`) {
                onChange(name, {...value, lower: fieldValue});
            }
            if (inputName === `${name}__upper`) {
                onChange(name, {...value, upper: fieldValue});
            }
        },
        preventNonDigitChars: (event: React.KeyboardEvent) => {
            const notAllowedCharCodes = ["Minus", "Period", "NumpadAdd", "NumpadSubtract", "Comma", "Equal"];

            if (notAllowedCharCodes.includes(event.code)) {
                event.preventDefault();
            }
        }
    };
    const errors = [props.error?.[0] ? [props.error[0]] : undefined, props.error?.[1] ? [props.error[1]] : undefined];

    return (
        <div className={classNames(rangeHolder, className)} ref={inputForwardedRef}>
            <div className={classNames(inputHolder, "rangeInputLower")}>
                <InputField
                    name={`${name}__lower`}
                    value={value && value.lower}
                    error={errors[0]}
                    onChange={(event) => {
                        handlers.onChange(event.currentTarget.name, event.currentTarget.value);
                    }}
                    placeholder="Od"
                    type="number"
                    pattern="[0-9]*"
                    min="0"
                    onKeyPress={handlers.preventNonDigitChars}
                    rightElement={props.rightElement}
                    dataTestId={dataTestIdLower}
                />
            </div>

            <span className={classNames(separator)}>-</span>

            <div className={classNames(inputHolder, "rangeInputUpper")}>
                <InputField
                    name={`${name}__upper`}
                    value={value && value.upper}
                    error={errors[1]}
                    onChange={(event) => {
                        handlers.onChange(event.currentTarget.name, event.currentTarget.value);
                    }}
                    placeholder="Do"
                    type="number"
                    pattern="[0-9]*"
                    min="0"
                    onKeyPress={handlers.preventNonDigitChars}
                    rightElement={props.rightElement}
                    dataTestId={dataTestIdUpper}
                />
            </div>
        </div>
    );
});
import React, {forwardRef} from "react";
import classNames from "classnames";

import {InputField} from "@pg-design/inputs-module";

import {inputHolder, rangeHolder, separator} from "./RangeInput.module.css";

export interface IRange<T> {
    lower: T;
    upper: T;
    bounds?: string;
}

type RangeLimitValue = string | number;

export interface IRangeProps {
    className?: string;
    name: string;
    value: IRange<RangeLimitValue>;
    error?: string | string[];
    onChange: (name: string, value: IRange<RangeLimitValue>) => void;
    rightElement?: React.JSX.Element | string;
    dataTestIdLower?: string;
    dataTestIdUpper?: string;
}

export const RangeInput = forwardRef<HTMLDivElement, IRangeProps>((props, inputForwardedRef) => {
    const {name, value, className, onChange, dataTestIdLower, dataTestIdUpper} = props;

    const handlers = {
        onChange: (inputName: string, fieldValue: string) => {
            if (inputName === `${name}__lower`) {
                onChange(name, {...value, lower: fieldValue});
            }
            if (inputName === `${name}__upper`) {
                onChange(name, {...value, upper: fieldValue});
            }
        },
        preventNonDigitChars: (event: React.KeyboardEvent) => {
            const notAllowedCharCodes = ["Minus", "Period", "NumpadAdd", "NumpadSubtract", "Comma", "Equal"];

            if (notAllowedCharCodes.includes(event.code)) {
                event.preventDefault();
            }
        }
    };
    const errors = [props.error?.[0] ? [props.error[0]] : undefined, props.error?.[1] ? [props.error[1]] : undefined];

    return (
        <div className={classNames(rangeHolder, className)} ref={inputForwardedRef}>
            <div className={classNames(inputHolder, "rangeInputLower")}>
                <InputField
                    name={`${name}__lower`}
                    value={value && value.lower}
                    error={errors[0]}
                    onChange={(event) => {
                        handlers.onChange(event.currentTarget.name, event.currentTarget.value);
                    }}
                    placeholder="Od"
                    type="number"
                    pattern="[0-9]*"
                    min="0"
                    onKeyPress={handlers.preventNonDigitChars}
                    rightElement={props.rightElement}
                    dataTestId={dataTestIdLower}
                />
            </div>

            <span className={classNames(separator)}>-</span>

            <div className={classNames(inputHolder, "rangeInputUpper")}>
                <InputField
                    name={`${name}__upper`}
                    value={value && value.upper}
                    error={errors[1]}
                    onChange={(event) => {
                        handlers.onChange(event.currentTarget.name, event.currentTarget.value);
                    }}
                    placeholder="Do"
                    type="number"
                    pattern="[0-9]*"
                    min="0"
                    onKeyPress={handlers.preventNonDigitChars}
                    rightElement={props.rightElement}
                    dataTestId={dataTestIdUpper}
                />
            </div>
        </div>
    );
});
